import type { en } from "./en";

// Hindi translations. Missing keys fall back to English via i18next.
export const hi: typeof en = {
  common: {
    home: "होम",
    no_scores: "अभी कोई स्कोर नहीं",
    points_count_one: "{{count}} अंक",
    points_count_other: "{{count}} अंक",
    questions_count_one: "{{count}} प्रश्न",
    questions_count_other: "{{count}} प्रश्न",
  },
  home: {
    placeholder: "गेम कोड",
    enter: "जुड़ो",
    error_invalid_code: "अपने शिक्षक से मिला 6-अक्षर का गेम कोड डालो।",
    footer: "Binogi.com के प्रोडक्ट्स से Binogi Buzz शुरू करो।",
    language_label: "भाषा",
  },
  errors: {
    generic: "कुछ गड़बड़ हो गई। कृपया फिर से कोशिश करें।",
    stale_client: "आपका पेज पुराना हो गया है — कृपया रीफ़्रेश करें।",
    session_not_found: "यह सेशन नहीं मिला।",
    session_not_open: "यह सेशन खत्म हो चुका है।",
    session_not_active: "यह प्रश्न या सेशन पहले ही खत्म हो चुका है।",
    not_teacher: "यह सिर्फ़ शिक्षक कर सकते हैं।",
    already_answered: "आप इस प्रश्न का उत्तर पहले ही दे चुके हैं।",
    wrong_question_index: "यह प्रश्न अभी शुरू नहीं हुआ है।",
    name_taken: "यह नाम पहले से लिया जा चुका है। कोई दूसरा नाम आज़माएँ।",
    character_busy: "अभी आपको कोई कैरेक्टर नहीं मिल सका — कृपया फिर से कोशिश करें।",
  },
  host: {
    input: {
      heading: "एक Buzz शुरू करें",
      lead:
        "अपने छात्र जिस Binogi पाठ पर काम कर रहे हैं उसका कोड डालें। हम उसके प्रश्न लोड करेंगे और एक सेशन बनाएंगे जिसे आप बोर्ड पर दिखा सकते हैं।",
      lesson_code_label: "पाठ कोड",
      placeholder_code: "BIH750",
      load_button: "पाठ लोड करें",
      try_hint: "आज़माएँ:",
      error_invalid_code: "एक Binogi पाठ कोड डालें, जैसे BIH750।",
      error_not_found: "कोड {{code}} का कोई पाठ नहीं मिला।",
      error_unreachable: "पाठ सर्वर से संपर्क नहीं हो सका। अपना कनेक्शन जाँचें और फिर से कोशिश करें।",
      error_no_questions: "पाठ {{code}} में ऐसे कोई प्रश्न नहीं हैं जिन्हें Buzz इस्तेमाल कर सके।",
      error_no_level_questions: "पाठ {{code}} में चुने गए स्तर का कोई प्रश्न नहीं है।",
    },
    loading: "पाठ लोड हो रहा है…",
    placeholder_title: "एक Binogi Buzz शुरू करें",
    tab_details: "विवरण",
    tab_questions: "प्रश्न",
    settings: "सेटिंग्स",
    number_of_students: "छात्रों की संख्या",
    fewer_students: "कम छात्र",
    more_students: "ज़्यादा छात्र",
    player_names: "खिलाड़ी के नाम",
    player_anonymous: "गुमनाम",
    player_self_chosen: "छात्र चुनें",
    language: "भाषा",
    language_teacher: "शिक्षक चुनें",
    language_students: "छात्र चुनें",
    time_per_question: "प्रति प्रश्न समय",
    time_option: "{{seconds}} सेकंड",
    start_button: "सेशन शुरू करें",
    start_disabled: "शुरू करने के लिए कक्षा का आकार चुनें",
    creating: "सेशन बन रहा है…",
    error_no_questions: "शुरू करने से पहले कम से कम एक प्रश्न रखें।",
    error_create_failed: "सेशन नहीं बन सका",
    error_load_failed: "पाठ लोड नहीं हो सका",
    no_session: "कोई सेशन चल नहीं रहा है।",
    back_to_review: "प्रश्नों पर वापस जाएँ",
    errors: {
      dismiss: "बंद करें",
      refresh: "रीफ़्रेश करें",
      attach_failed: "यह स्क्रीन शिक्षक के रूप में नहीं जुड़ सकी।",
      unreachable: "सर्वर से संपर्क नहीं हो सका। फिर से कोशिश करने के लिए पेज रीफ़्रेश करें।",
      no_token: "यह टैब अब क्विज़ नहीं चला सकता। नया सेशन शुरू करने के लिए अपने पाठ से Buzz खोलें।",
      taken_over: "यह क्विज़ अब किसी दूसरी स्क्रीन से चलाया जा रहा है।",
      stale_question: "इस क्विज़ के दौरान Buzz अपडेट हो गया, इसलिए यह स्क्रीन इसे आगे नहीं चला सकती। क्लास जहाँ है वहीं से क्विज़ जारी रखने के लिए पेज रीलोड करें।",
      question_moved_on: "क्विज़ पहले ही आगे बढ़ चुका है, इसलिए यह स्क्रीन पीछे रह गई है। क्लास जहाँ है वहीं से क्विज़ जारी रखने के लिए पेज रीलोड करें।",
    },
    entry: {
      opening: "शिक्षक व्यू खुल रहा है…",
      token_title: "यह शिक्षक लिंक नहीं खुल सकता",
      token_body: "लिंक में शिक्षक कुंजी नहीं है या उसकी समय-सीमा खत्म हो गई है। नया सेशन बनाने के लिए अपने पाठ से Buzz खोलें।",
      not_found_title: "सेशन नहीं मिला",
      not_found_body: "यह क्विज़ सेशन अब मौजूद नहीं है। जारी रखने के लिए नया सेशन बनाएँ।",
      back: "शुरुआत पर वापस जाएँ",
    },
    questions: {
      drag_aria: "क्रम बदलने के लिए खींचें",
      remove_aria: "प्रश्न हटाएँ",
      empty: "इस सेशन में कोई प्रश्न नहीं बचा।",
      add: "जोड़ें",
      add_aria: "प्रश्न जोड़ें: {{text}}",
      add_all: "सभी जोड़ें",
      add_all_n: "सभी {{count}} प्रश्न जोड़ें",
      more_one: "इस पाठ में {{count}} प्रश्न और",
      more_other: "इस पाठ में {{count}} प्रश्न और",
      level_easy: "आसान",
      level_medium: "मध्यम",
      level_hard: "कठिन",
      multi: "बहुविकल्प",
    },
    lobby: {
      go_to: "<strong>buzz.binogi.com</strong> पर जाओ और डालो:",
      or_qr: "…या QR कोड स्कैन करो",
      students_joined_of: "{{expected}} में से {{joined}} छात्र जुड़ चुके हैं",
      students_joined_one: "{{count}} छात्र जुड़ चुका है",
      students_joined_other: "{{count}} छात्र जुड़ चुके हैं",
      waiting: "छात्रों के जुड़ने का इंतज़ार…",
      start_game: "गेम शुरू करें",
      connected: "जुड़ा हुआ",
      connecting: "जुड़ रहा है…",
      copy_link: "लिंक कॉपी करें",
      copy_link_copied: "कॉपी हो गया!",
    },
    question: {
      header: "प्रश्न {{index}} / {{total}}",
      level: "स्तर {{level}}",
      none: "कोई सक्रिय प्रश्न नहीं।",
      answered: "उत्तर दिए",
      top_n: "टॉप {{count}}",
      answers_heading: "उत्तर",
      end_question: "प्रश्न समाप्त करें",
      next_question: "अगला प्रश्न",
      see_results: "अंतिम परिणाम देखें",
    },
    results: {
      heading: "अंतिम परिणाम",
      all_players: "सभी खिलाड़ी",
      end_session: "सेशन समाप्त करें",
      new_session: "नया सेशन",
      none: "इस सेशन में कोई खिलाड़ी नहीं।",
    },
  },
  join: {
    code_label: "गेम कोड",
    name_label: "तुम्हारा नाम",
    name_placeholder: "अपना नाम लिखो",
    join_button: "जुड़ो",
    joining: "जुड़ रहे हैं…",
    checking: "जाँच हो रही है…",
    character_hint: "जुड़ने पर तुम्हें एक मज़ेदार Binogi किरदार का नाम मिलेगा।",
    error_not_found:
      "यह कोड अभी किसी लाइव सेशन का नहीं है। अपने शिक्षक से जाँच लो।",
    error_lookup_failed: "सेशन नहीं मिला",
    error_code_required: "6-अक्षर का कोड डालो।",
    error_name_required: "अपना नाम लिखो।",
  },
  play: {
    superseded: "आप दूसरे टैब में जुड़े हुए हैं — यहाँ खेलते रहने के लिए उसे बंद करें।",
    back_to_join: "जुड़ने पर वापस जाएँ",
    no_round: "इस राउंड का कोई डेटा नहीं।",
    not_joined: "आप किसी सेशन से नहीं जुड़े हैं।",
    no_question: "कोई सक्रिय प्रश्न नहीं।",
    keep_awake_hint: "स्क्रीन चालू रखने के लिए उस पर टैप करें",
    waiting: {
      you_are: "तुम हो",
      get_ready_named: "तैयार हो जाओ, {{name}}!",
      get_ready: "क्विज़ के लिए तैयार हो जाओ!",
      in_room_label: "कमरे में छात्र",
      in_room_one: "कमरे में {{count}} छात्र",
      in_room_other: "कमरे में {{count}} छात्र",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "उत्तर दिया!",
      times_up: "समय समाप्त",
      submit: "भेजो",
      submit_n: "{{count}} उत्तर भेजो",
    },
    between: {
      correct: "सही!",
      wrong: "लगभग सही",
      times_up: "समय समाप्त",
      points_gained: "+{{count}} अंक",
      your_score: "तुम्हारा स्कोर",
      your_rank: "तुम्हारा स्थान {{rank}}",
      top_n: "टॉप {{count}}",
      waiting_next: "अगले प्रश्न का इंतज़ार…",
    },
    finished: {
      heading: "Binogi Buzz खेलने के लिए धन्यवाद!",
      your_final_rank: "तुम्हारी अंतिम रैंक",
      top_n: "टॉप {{count}}",
      none: "दिखाने के लिए कोई परिणाम नहीं।",
    },
  },
  characters: {
    heading: "Binogi किरदार",
    lead:
      "जुड़ने पर {{count}} छात्रों को इसी क्रम में एक किरदार मिलता है।",
  },
};
